'use client';

import { logError } from '@/domains/common/logger.client';
import { type FunctionComponent, useEffect } from 'react';

interface Props {
  error: Error & { digest?: string };
}

// Required for Sentry to capture errors that escape the React tree,
// including ones thrown during root-layout rendering.
const GlobalError: FunctionComponent<Props> = ({ error }) => {
  useEffect(() => {
    logError(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <h1>Something went wrong</h1>
      </body>
    </html>
  );
};

export default GlobalError;
